import Axios from 'axios';

/**
 * Installment agreement the institution sends already closed. `preview` reads and
 * validates the list without charging anything, which is what lets the operator
 * check the values before the student gets a boleto.
 */
export default {
  preview(payload) {
    return Axios.post('/admin/agreement-contracts/preview', payload)
      .then(({ data }) => data);
  },

  createAgreement(payload) {
    return Axios.post('/admin/agreement-contracts', payload)
      .then(({ data }) => data);
  },
};
